import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { WizardOption } from 'src/app/models/wizard/wizard-option';
import { ConfigService } from 'src/app/services/config/config.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { WizardStepName } from 'src/app/services/wizard/wizard-step-name.enum';

@Component({
  selector: 'app-wizard-tile',
  templateUrl: './wizard-tile.component.html',
  styleUrls: ['./wizard-tile.component.scss']
})
export class WizardTileComponent implements OnInit {

  @Input() wizardOption: WizardOption = new WizardOption();
  @Input() isSelected?: boolean;
  @Input() iconFontSet?: string;
  @Input() iconName?: string;
  @Input() isAlignTextLeft: boolean = false;
  @Input() removeBottomPadding: boolean = false;
  @Input() tooltipText: string = "";
  @Input() isSingleOption: boolean = false;
  @Input() currentStepName: string = "";
  @Input() selectionType?: string;
  @Input() index: number = 0;

  @Output() onSelectEvent = new EventEmitter<any>();

  rippleColor: string = "";
  isRadioTile: boolean = false;
  isCheckboxTile: boolean = false;
  isBrandsStep: boolean = false;

  constructor(private confSvc: ConfigService, private analytics: AnalyticsService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();
    this.rippleColor = this.confSvc.getString("materialTileRippleColor");

    this.isRadioTile = this.selectionType === "radio";
    this.isCheckboxTile = this.selectionType === "checkbox";
    this.isBrandsStep = this.wizardOption.step.name == WizardStepName.Brands;
  }

  onTileSelected(event: any): void {
    event.preventDefault();
    this.isSelected = this.isSingleOption ? true : !this.isSelected;
    this.wizardOption.isSelected = this.isSelected;
    this.onSelectEvent.emit(this.wizardOption);
    this.analytics.logWizardTileClick(this.wizardOption.title, this.isSelected, this.currentStepName)
  }
}
